import { useTranslation } from 'hooks/useTranslation'
import { InformationCollapse, InformationCollapseType } from 'components/InformationCollapse'
import { FAQRoot, FAQContainer, FAQTitle, InformationWrapper } from './FAQ.styles'
import { Text } from 'components/Text'

const faqItems: InformationCollapseType[] = [
  {
    label: 'products-v2:freeze-dried-raw-nuggets.faq.1.question',
    description: 'products-v2:freeze-dried-raw-nuggets.faq.1.answer',
  },
  {
    label: 'products-v2:freeze-dried-raw-nuggets.faq.2.question',
    description: 'products-v2:freeze-dried-raw-nuggets.faq.2.answer',
  },
  {
    label: 'products-v2:freeze-dried-raw-nuggets.faq.3.question',
    description: 'products-v2:freeze-dried-raw-nuggets.faq.3.answer',
  },
  {
    label: 'products-v2:freeze-dried-raw-nuggets.faq.4.question',
    description: 'products-v2:freeze-dried-raw-nuggets.faq.4.answer',
  },
]

export const FAQ = () => {
  const { t } = useTranslation()

  return (
    <FAQRoot>
      <FAQContainer>
        <Text as="h2" size="h4">
          {t('products-v2:freeze-dried-raw-nuggets.faq.title')}
        </Text>
        <InformationWrapper>
          <InformationCollapse v2 infoList={faqItems} />
        </InformationWrapper>
      </FAQContainer>
    </FAQRoot>
  )
}

FAQ.displayName = 'FAQ'
